import { useTranslation } from 'react-i18next'

import { SearchCascader, TSearchCascaderProps } from 'App/components/common/Fields/SearchCascader'
import {
  useStaffSearchByOptions,
  TUseStaffSearchByOptionsProps
} from 'App/hooks/SearchCascader/useStaffSearchByOptions'
import { EInputSize } from 'enums'

export type TStaffSearchCascaderProps = Pick<TSearchCascaderProps, 'onSearchChange'> &
  TUseStaffSearchByOptionsProps

export const StaffSearchCascader = ({
  onSearchChange,
  onChange,
  organizationId
}: TStaffSearchCascaderProps) => {
  const { onCascaderChange, options } = useStaffSearchByOptions({ onChange, organizationId })

  const { t } = useTranslation()

  return (
    <SearchCascader
      searchSize={EInputSize.L}
      placeholder={t('modal.broadcastMessage.recipientsStep.searchPlaceholder_staff')}
      options={options}
      triggerInitialOnChange={true}
      onSearchChange={onSearchChange}
      onCascaderChange={onCascaderChange}
    />
  )
}
